import { LangCode } from "src/requests/localization/types";

// Map that will convert Backend localization (LangCode) to Frontend defined messages (LocalizedText)
export enum LangCodeToLocalizedText {
  cs = "cz",
  en = "en",
}

export const mapLangCodeToLocalizedTextCode = (lang: LangCode) =>
  LangCodeToLocalizedText[lang] as LangCodeToLocalizedText;
